<template>
    <div id="app">
        <input v-model="img.src">
        <div v-if="img.loading" class="">gewwg</div>

        <cropper
                classname="cropper"
                :src="img.src"
                :stencilProps="{
                aspectRatio: 16/9,
                imageRestriction: 'area',
                }"
                @change="change"
                ref="cropper"
        ></cropper>
        <img :src="preview" width="300"/>
        {{ JSON.stringify(fff) }}htrh
        <b-form-file
                @change="uploadImage($event)"
                v-model="fff"
                :state="Boolean(fff)"
                accept=".jpg, .png, .gif"
                ref="file-input"
                placeholder="選擇檔案"
                drop-placeholder="Drop file here..."
        ></b-form-file>
        <b-button pill variant="primary text-white ActionBtnBg"  block @click="reset">Reset</b-button>
        <b-button pill variant="primary text-white ActionBtnBg"  block @click="upload">upload</b-button>
    </div>

</template>
<style>
    .cropper {
        width: 300px;
        height: 300px;
    }
</style>
<script>
import { Cropper } from 'vue-advanced-cropper'

export default {
  name: 'Agreement',
  components: {
    Cropper
  },
  data () {
    return {
      fff:null,
      img: {
        src: 'https://images.pexels.com/photos/1055424/pexels-photo-1055424.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        loading: false,
        blob:null,
        preview: null
      },
      preview: null
    }
  },
  watch: {
    'img.src' (value) {
      console.log(value)
      if (value) {
        this.img.loading = true
      }
    }
  },
  methods: {
    uploadImage(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.img.src = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    reset() {
      this.img.src = null;
      this.img.loading = false;
      this.preview = false;
      this.$refs['file-input'].reset()
    },
    change({coordinates, canvas}){
      this.preview = canvas
      canvas.toBlob(blob => {
        console.log(blob)
        this.img.blob = blob
        this.preview = URL.createObjectURL(blob)
      }, 'image/jpeg',0.5)
    },
    upload () {
      const form = new FormData()
      let blobsize = this.img.blob.size/1024
      if(blobsize < 1000){
        form.append('file', this.img.blob);
        this.$store.dispatch('actionPostUpload', form).then((res) => {
          console.log(res)
        }).catch((res) => {
          console.log(res)
        })

      }


    }
  },

}
</script>

<style scoped>

</style>
